import { BaseExportService } from "./BaseExportService";

export class TelephoneExportService extends BaseExportService {
  constructor(data, metadata = {}) {
    super(data, metadata);
  }

  get_filename_prefix() {
    return `Telephones_Report_${this.data?.IdNumber || "Unknown"}`;
  }

  get_available_sections() {
    return {
      telephone_results: "Telephone Results",
      raw_json: "Raw JSON Data",
    };
  }

  get_default_export_options() {
    return {
      telephone_results: true,
      raw_json: false,
    };
  }

  prepare_export_data(export_options) {
    const export_data = {};

    if (export_options.telephone_results) {
      export_data.telephone_results = this.prepare_telephone_results();
    }

    if (export_options.raw_json) {
      export_data.raw_json = [this.data];
    }

    return export_data;
  }

  prepare_telephone_results() {
    const telephones = this.data?.Telephones || [];

    const output_fields = []
    for (const tel of telephones) {
        output_fields.push({
            IDNumber: tel.IDNumber,
            TelNumber: tel.TelNumber,
            TelType: tel.TelType,
            FirstDate: tel.FirstDate,
            LatestDate: tel.LatestDate,
            LatestStatus: tel.LatestStatus,
            Score: tel.Score,
            IsDiallable: tel.IsDiallable,
            IsValid: tel.IsValid,
            BusinessName: tel.BusinessName,
            Occurrences: tel.Occurrences
        })
    }
    return output_fields;
  }
}
